/**
 * Chip de estado de cuenta de una casa (átomo de design-system compartido).
 *
 * Fuente única de verdad del color + etiqueta de cada `EstadoCasa`, usado por
 * la grilla anual de Tesorería (`GrillaCasasAnual`) y por el reporte de ficha
 * de vecino de la Comisión (`ConsultaVecinos`). Los colores NO salen de la
 * paleta `state` del tema (que no tiene amarillo): son colores propios del
 * dominio casa —verde/amarillo/rojo/naranja— para que ambas vistas sean
 * consistentes. Extraído aquí (antes vivía en GrillaCasasAnual).
 */
import type { EstadoCasa } from '../../lib/api/casas-tesoreria';

export const ESTILO_ESTADO_CASA: Record<
  EstadoCasa,
  { bg: string; text: string; label: string }
> = {
  al_dia: { bg: 'rgba(95,217,177,0.14)', text: '#5fd9b1', label: 'Al día' },
  al_dia_pendiente_semestre: {
    bg: 'rgba(255,221,87,0.16)',
    text: '#ffdb5a',
    label: 'Al día (con saldo)',
  },
  atrasada: { bg: 'rgba(255,122,122,0.14)', text: '#ff7a7a', label: 'Atrasada' },
  suspendida: {
    bg: 'rgba(255,183,117,0.14)',
    text: '#ffb775',
    label: 'Suspendida',
  },
};

export function EstadoCasaBadge({ estado }: { estado: EstadoCasa }) {
  const s = ESTILO_ESTADO_CASA[estado];
  return (
    <span
      className="inline-flex text-[10px] px-2 py-0.5 rounded-full"
      style={{ backgroundColor: s.bg, color: s.text }}
    >
      {s.label}
    </span>
  );
}
